import {
  Code2,
  Cpu,
  Database,
  HardDrive,
  LayoutGrid,
  Network,
  Server,
  type LucideIcon,
} from "lucide-react";

// ── SSP Cylinder Layers ───────────────────────────────────
export type SspLayerKey =
  | "application"
  | "data"
  | "runtime"
  | "compute"
  | "storage"
  | "platform"
  | "network";

export const SSP_LAYERS: {
  key: SspLayerKey;
  label: string;
  icon: LucideIcon;
  gradient: string;
  dot: string;
  // [top-highlight, mid, side-shadow] hex values for the SVG cylinder ring
  colors: [string, string, string];
}[] = [
  {
    key: "application",
    label: "Application",
    icon: LayoutGrid,
    gradient: "from-purple-500 to-fuchsia-500",
    dot: "bg-purple-400",
    colors: ["#9B4DFF", "#7B3FF2", "#5F2EEA"],
  },
  {
    key: "data",
    label: "Data",
    icon: Database,
    gradient: "from-pink-500 to-rose-500",
    dot: "bg-pink-400",
    colors: ["#FF4FA5", "#D63384", "#A61E6A"],
  },
  {
    key: "runtime",
    label: "Runtime",
    icon: Code2,
    gradient: "from-red-500 to-orange-500",
    dot: "bg-red-400",
    colors: ["#FF5C7A", "#E63963", "#C9184A"],
  },
  {
    key: "compute",
    label: "Compute",
    icon: Cpu,
    gradient: "from-orange-500 to-amber-500",
    dot: "bg-orange-400",
    colors: ["#FF9F1C", "#F77F00", "#D66B00"],
  },
  {
    key: "storage",
    label: "Storage",
    icon: HardDrive,
    gradient: "from-lime-500 to-emerald-500",
    dot: "bg-emerald-400",
    colors: ["#8AC926", "#6BAF00", "#4F8C00"],
  },
  {
    key: "platform",
    label: "Datacenter / Platform",
    icon: Server,
    gradient: "from-teal-500 to-cyan-500",
    dot: "bg-teal-400",
    colors: ["#2EC4B6", "#1AA6A0", "#0F8B8D"],
  },
  {
    key: "network",
    label: "Network",
    icon: Network,
    gradient: "from-sky-500 to-blue-500",
    dot: "bg-sky-400",
    colors: ["#4D8DFF", "#3366FF", "#2451D6"],
  },
];
